import React, { useEffect, useState } from 'react';
import { MotionDurationsSeconds, Transitions, createTransition, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import { AnimatePresence, motion } from 'framer-motion';
import { GalleryVariants } from '@polestar/component-warehouse-react/components/gallery/Gallery';
import GalleryCaption from '@polestar/component-warehouse-react/components/gallery/GalleryCaption';
import { createCustomSpacing } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import styled from '@emotion/styled';
/**
 * @internal
 *
 * We need to wrap the indicator because the internal active index and the index we give back is different
 * This is because we duplicate the content, so it's always twice as long.
 *
 * This wrapper also makes sure that only the indicator components re-renders when changing slides, the gallery and slides don't
 */
export const TextIndicator = ({ clampedIndex, length, captions, variant, ...props }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [initialOpacity, setInitialOpacity] = useState(1);
    useEffect(() => {
        setInitialOpacity(0);
    }, []);
    useEffect(() => clampedIndex.on('change', (latestActiveIndex) => {
        setActiveIndex(latestActiveIndex);
    }), [clampedIndex]);
    const transition = createTransition({
        ...Transitions.default,
    });
    return (React.createElement(AnimatePresence, null,
        React.createElement(IndicatorMotionWrapper, { key: "indicator-motion-wrapper" },
            React.createElement(IndicatorWrapper, { key: activeIndex, initial: {
                    opacity: initialOpacity,
                }, animate: {
                    opacity: 1,
                    transition: {
                        delay: MotionDurationsSeconds.fast,
                    },
                }, exit: {
                    opacity: 0,
                }, transition: transition, ...props },
                React.createElement(GalleryCaption, { captions: captions, length: length, activeIndex: activeIndex, hideIndicator: variant === GalleryVariants.standard })))));
};
TextIndicator.displayName = 'TextIndicator';
export default TextIndicator;
const IndicatorMotionWrapper = styled.div `
  position: relative;
  width: 100%;
  min-height: ${createCustomSpacing(34 / 16)};
`;
const IndicatorWrapper = styled(motion.div) `
  position: relative;
  display: flex;
  width: 100%;
`;
